import { Typography } from '@mui/material';

import theme from '../../theme';
import { EwsStatus } from '../../types';

export const EWS_NOT_FOUND_NOTE = 'EWS: account not found, verified by Passport';

// Passport activated the account even though EWS could not identify it.
// Informational only: must not block any action on the account.
export const shouldShowEwsNotFoundNote = (
  provisionStatus?: string | null,
  ewsStatus?: EwsStatus | null,
) => provisionStatus === 'Completed' && ewsStatus === 'NOT_FOUND';

type AchEwsNoteProps = {
  provisionStatus?: string | null;
  ewsStatus?: EwsStatus | null;
};

const AchEwsNote = ({ provisionStatus, ewsStatus }: AchEwsNoteProps) => {
  if (!shouldShowEwsNotFoundNote(provisionStatus, ewsStatus)) {
    return null;
  }

  return (
    <Typography
      sx={{
        color: theme.palette.text.secondary,
        fontSize: '12px',
        lineHeight: '16px',
        fontFamily: 'Inter',
        marginTop: '2px',
      }}
    >
      {EWS_NOT_FOUND_NOTE}
    </Typography>
  );
};

export default AchEwsNote;
